import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { UploadedFileResponse } from './uploaded-file-response';

@Component({
    selector: 'uploaded-file-errors',
    template: require('./uploaded-file-errors.component.html'),
    styles: [require('./uploaded-file-errors.component.scss')],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class UploadedFileErrorsComponent {
    @Input()
    public fileResponse: UploadedFileResponse;
}
